import type { AdministrationProviderConfig } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import { useDeleteInventoryList } from './utils/inventoryLists/useDeleteInventoryList';
import { useInventoryListByIdFetch } from './utils/inventoryLists/useInventoryListByIdFetch';
import { useInventoryListsFetch } from './utils/inventoryLists/useInventoryListsFetch';
import { useSubmitInventoryList } from './utils/inventoryLists/useSubmitInventoryList';
import { useAccountOptionsFetch } from './utils/users/useAccountOptionsFetch';
import { useCreateUser } from './utils/users/useCreateUser';
import { useEditUser } from './utils/users/useEditUser';
import { useGetUsersTableData } from './utils/users/useGetUsersTableData';
import { useUserDeleteModal } from './utils/users/useUserDeleteModal';
import { useUserFetch } from './utils/users/useUserFetch';
import { useUserPageHeaderActions } from './utils/users/useUserPageHeaderActions';
import { useUsersListFetch } from './utils/users/useUsersListFetch';

export const administrationConfig: AdministrationProviderConfig = {
  isOa: true,
  useAccountOptionsFetch,
  useCreateUser,
  useGetUsersTableData,
  useUsersListFetch,
  useDeleteInventoryList,
  useInventoryListByIdFetch,
  useInventoryListsFetch,
  useSubmitInventoryList,
  useUserFetch,
  useUserPageHeaderActions,
  useEditUser,
  useUserDeleteModal,
};
